import {useCallback, useEffect, useState} from 'react';
import {useSelector, useStore} from 'react-redux';
import {WtbOverlay} from '~/common/fabric/CreateDesign/components/WhatToBring/WhatToBringOverlay';
import {CREATE_EDIT_WTB} from '~/common/fabric/reducers/widgets';
import {selectHasWtb} from '~/common/fabric/reducers/widgets/selectors';
import {OptionWrapper} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/Options/components/OptionWrapper';
import {WhatToBringModule} from '~/ViewInvitation/routes/Landing/WhatToBringModule';
import {WhatToBringLineIcon} from '~library/svg/WhatToBringLineIcon';

export const WhatToBring = () => {
  const store = useStore();
  const hasWtb = useSelector((state) => selectHasWtb(state));
  const [showOverlay, setShowOverlay] = useState(false);
  const [wtbSwitchOn, setWtbSwitchOn] = useState(hasWtb);
  const [wtbListenForChanges, setWtbListenForChanges] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const openOverlay = useCallback(() => {
    setShowOverlay(true);
  }, [setShowOverlay]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const closeOverlay = useCallback(() => {
    setShowOverlay(false);
  }, [setShowOverlay]);

  const wtbOverlayCallback = useCallback(() => {
    setWtbSwitchOn(true);
  }, []);

  const wtbHandlePanelClose = useCallback(
    (wtb) => {
      if (!wtb) {
        setWtbSwitchOn(false);
      }
      setWtbListenForChanges(false);
      closeOverlay();
    },
    [closeOverlay]
  );

  const handleEditWtb = useCallback(() => {
    openOverlay();
  }, [openOverlay]);

  const clearWtbData = useCallback(() => {
    store.dispatch({
      type: CREATE_EDIT_WTB,
      payload: {whatToBrings: []},
    });
  }, [store]);

  const resetWtbState = useCallback(() => {
    clearWtbData();
    closeOverlay();
    setWtbListenForChanges(true);
  }, [clearWtbData, closeOverlay]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  useEffect(() => {
    if (wtbListenForChanges) {
      if (!hasWtb) {
        openOverlay();
      } else {
        resetWtbState();
      }
    } else if (!hasWtb) {
      setWtbListenForChanges(true);
    } else if (!wtbSwitchOn) {
      resetWtbState();
    }
  }, [wtbSwitchOn]);

  return (
    <>
      <OptionWrapper
        icon={<WhatToBringLineIcon />}
        title="Add a What to Bring List"
        subtitle="Organize contributions & list items to bring to your event."
        onEdit={handleEditWtb}
        isActive={hasWtb}
        onRemove={resetWtbState}
      >
        <WhatToBringModule store={store} readonly />
      </OptionWrapper>
      <WtbOverlay
        isOpen={showOverlay}
        onClose={wtbHandlePanelClose}
        overlayCallback={wtbOverlayCallback}
        title="What to Bring List"
        body="Tell guests exactly what you want them to bring to your event. (PS: you can keep updating this after you've sent your Invitation.)"
        hasWtb={hasWtb}
      />
    </>
  );
};
